import React from 'react'
import HomeBanner from '../Home/HomeSections/Homebanner'
import Header from '../Layout/Header'
import Category from './Category'
import Testimonials from '../Home/HomeSections/Testimonials'
import Lorem from '../Home/HomeSections/Lorem'
import Footer from '../Layout/Footer'

export default function CaseStudies() {
  return (
    <div>
        <Header/>
        <HomeBanner
          title='Success Stories: Exploring Our Case Studies and Client Successes' 
          subtitle={`See what our customers are saying about Toromail's game-changing AI-powered email replies. Discover how businesses are streamlining their customer service process, improving response time, and increasing overall customer satisfaction.`}
          OrangeBtn='true'
          GrayBtn='true'
          />
          <Category ContentClassName='order-2 relative' ImageClassName='order-1 relative'/>
          <Category ClasName='!bg-white' ContentClassName='600:order-1 relative' ImageClassName='600:order-2 relative'/>
          <Category ContentClassName='order-2 relative' ImageClassName='order-1 relative'/>
          <Category ClasName='!bg-white' ContentClassName='600:order-1 relative' ImageClassName='600:order-2 relative'/>
          <Testimonials/>
          <Lorem/>
          <Footer />
    </div>
  )
}
